module.exports = __webpack_public_path__ + "static/media/temporary2.b7732d9a.png";